<!-- headings -->

<div class="flex flex-middle wrap">
  @for (section of visibleSections; track section; let index = $index) {
    @if (index) {
      <div
      class="vbar m-l-2 m-r-2"></div>
    }
    <h6 [class.cursor-pointer]="hasManySections"
      zippyClass="col-1 !col-4"
      class="h2"
      [zippyOpen]="[uid, index]"
      [zippyOpenOff]="!hasManySections"
      *iCms="'title' of section"
    text></h6>
  }
</div>

<!-- contents -->
@for (section of component?.sections; track sectionTrackFn(index); let index = $index) {
  <div
    [hidden]="!isVisible(section)"
    [zippy]="[uid, index]"
    [zippyAuto]="true"
    [zippyOff]="!isVisible(section) || !hasManySections">
    <!-- section products -->
    <related-products [source]="product"
      [limit]="section.limit || 8"
      [options]="getOptions(section)"
      (isPrinted)="onPrinted($event, section, index)">
      <!-- section copy -->
      <p *iCms="'copy' of section; skipEmpty: true"
        text
      class="m-t-2 col-12 p1 w-5 w-12-s w-12-m"></p>
    </related-products>
  </div>
}